var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    [0, 1].includes(this.status)
      ? _c("span", { staticClass: "status ing" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/image/governance/icon1.png"),
              alt: "",
            },
          }),
          _vm._v("Ongoing\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    [4, 5, 7, 8].includes(this.status)
      ? _c("span", { staticClass: "status passed" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/image/governance/icon2.png"),
              alt: "",
            },
          }),
          _vm._v("Passed\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    [2, 3, 6].includes(this.status)
      ? _c("span", { staticClass: "status failed" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/image/governance/icon3.png"),
              alt: "",
            },
          }),
          _vm._v("Failed\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }